import { inject, Pipe, PipeTransform } from '@angular/core';
import { DISTANCE_SERVICE, DistanceUnit } from '@luggagehero/shared/interfaces';
import { Observable } from 'rxjs';

@Pipe({ name: 'lhDistance', standalone: true })
export class DistancePipe implements PipeTransform {
  private distanceService = inject(DISTANCE_SERVICE);

  transform(
    meters: number,
    distanceUnit: DistanceUnit = 'metric',
    includefrom = true,
    place?: string,
  ): Observable<string> {
    return this.distanceService.convertDistance(meters, distanceUnit, includefrom, place);
  }
}
